import script from "./Co2QuizResults.vue?vue&type=script&lang=ts&setup=true"
export * from "./Co2QuizResults.vue?vue&type=script&lang=ts&setup=true"

import "./Co2QuizResults.vue?vue&type=style&index=0&id=3ef3c2e8&lang=css"

const __exports__ = script;

export default __exports__